import PluginSelect from './PluginSelect.vue'

export default PluginSelect